import { useQuery } from '@tanstack/react-query';
import { useTenantApi } from '@/account/hook/useTenantApi';
import { registration } from '@/api';
import { useEffect } from 'react';
import { useApiErrorHandler } from '@/account/hook/useApiErrorHandler';
import { useUserSession } from './useUserSession';

export function useLocaleListQuery(eventId: string) {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const { userSession } = useUserSession();
  const { reportToGlobal } = useApiErrorHandler();
  const query = useQuery({
    queryKey: [registration.localeListQueryKey, { eventId }, { email: userSession?.email }],
    queryFn: async () => {
      return await registration.loadLocaleList(createTenantApiRequest)({
        eventId,
      });
    },
    enabled: !isApiPreparing && !!eventId,
  });

  useEffect(() => {
    if (query.error) {
      reportToGlobal(query.error as Error);
    }
  }, [
    query.error,
  ]);

  return query;
}
